import React, {useContext} from 'react';
import logo from '../../../../../assets/security-details-upload-order-list.svg';
import styles from '././download-orders-list.module.scss';
import SecurityService from '../../../../../services/security-service';
import { SecurityContext } from "../../../../../context/security-context";


const DownloadOrdersList = () => {
  const action = 'Download Reservation List';
  const securityService = new SecurityService();
  const { securityState } = useContext(SecurityContext);

  const downloadFileHandler = () => {
    const downloadConsolidatedFile = async () => {
      let resp = await securityService.downloadOrderList(securityState['securityId']);
      window.open(resp['s3FileUrl']);
    }
    downloadConsolidatedFile();
  }

  return (
    <>
      <div onClick={()=>downloadFileHandler()} className={styles['logo']}>
        <img alt={action} src={logo} />
        <label>{action}</label>
      </div>
    </>
  );
}



export default DownloadOrdersList;

